import {Component, ElementRef, OnInit} from '@angular/core';
import {ADMINROUTES, ROUTES} from '../sidebar/sidebar.component';
import {Location} from '@angular/common';
import {Router} from '@angular/router';
import {AuthenticationService} from '../../services/authentication/authentication.service';
import {Role} from '../../models/roles';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  public focus;
  public listTitles: any[];
  public location: Location;


  constructor(location: Location,  private element: ElementRef, private router: Router, private authenticationService: AuthenticationService) {
    this.location = location;
  }

  ngOnInit() {
      if (this.authenticationService.currentUserValue.role === Role.Admin) {
        this.listTitles = ADMINROUTES.filter(listTitle => listTitle);

        this.listTitles.push({ path: '/admin/editforms',         title: 'فرم جدید / ویرایش'});
        this.listTitles.push({ path: '/admin/edituser',         title: 'ویرایش کاربر'});
      } else {
        this.listTitles = ROUTES.filter(listTitle => listTitle);

      }
  }
  getTitle() {
    let titlee = this.location.prepareExternalUrl(this.location.path());
    if (titlee.charAt(0) === '#') {
        titlee = titlee.slice( 1 );
    }

    for (let item = 0; item < this.listTitles.length; item++) {
        if (this.listTitles[item].path === titlee) {
            return this.listTitles[item].title;
        }
    }
    return 'خوش آمدید!';
  }

}
